import React from "react";
import MainTemplate from "../../components/MainTemplate/MainTemplate";
import CardBackground from "../../components/MainTemplate/CardBackground";
import ManageConsultantsChild from "./ManageConsultantsChild";

const ManageConsultants = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ManageConsultantsChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default ManageConsultants;
